import i18n from 'i18next';
import React from 'react';
import useStyles from './EmptyBody.styles';

const EmptyBody = () => {
  const classes = useStyles();

  return (
    <tbody>
      <tr>
        <td>
          <p className={classes.message}>{i18n.t('common.userInterface.noDataToDisplay')}</p>
        </td>
      </tr>
    </tbody>
  );
};

EmptyBody.propTypes = {};

EmptyBody.defaultProps = {};

export default EmptyBody;
